import { useState, useEffect } from "react";
import { useUser } from "src/shared/context/UserContext";

export const useAppearance = () => {
  const { user } = useUser();
  const [background, setBackground] = useState<string>("");
  const [fontFamily, setFontFamily] = useState<string>("");

  useEffect(() => {
    const storedColor = user?.themes.backgroundColour;
    const fontFamily = user?.themes.fontFamily;
    
    if (storedColor) {
      setBackground(storedColor);
    }
    
    if (fontFamily) {
      setFontFamily(fontFamily);
      document.documentElement.style.setProperty("--fontfamily", fontFamily);
    }
  }, []);

  return { background, fontFamily };
};